var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConsolidationDetailUser',{attrs:{"consolidation":_vm.consolidation},on:{"print":_vm.printPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }